import { createStore } from 'vuex'
import UserModule from "./User.store";
import AdminModule from "./Admin.store"
import UserService from "@/services/User.service"
import QuestionModule from './Question.store';


export default createStore({
  state: {
    modal: {
      show: false
    },
    modalContactUs: false,
    formContactUs: {
      nome: "",
      email: "",
      mensagem: ""
    }
  },
  mutations: {
    showModal(state, show) {
      state.modal.show = show
    },
    showModalContactUs(state, show) {
      state.modalContactUs = show
    },
    setFormContactUs(state, show) {
      state.formContactUs = show
    }

  },
  actions: {
    async sendContactUs(context) {
      var service = new UserService();
      var statusCode, form, res;

      form = context.state.formContactUs;

      try {
        var res = await service.sendContactUs(form);
        statusCode = res.status;

      } catch (error) {
        if (error.response) {
          statusCode = error.response.status;
        }
      }

      statusCode = 200;
      // console.log('statusCode', statusCode)

      if (statusCode == 200) {
        return { status: true, message: "Seu e-mail foi enviado com sucesso" }
      } else {
        return { status: false, message: "Erro ao enviar" }
      }
    }
  },
  modules: {
    user: UserModule,
    admin: AdminModule,
    question: QuestionModule
  },
  getters: {
    showModal: state => state.modal.show,
    modalContactUs: state => state.modalContactUs,
    formContactUs: state => state.formContactUs,
  }
})
